<h3 mat-dialog-title>{{ saveMode + 'SetOfFilters' | translate }}</h3>

<form [formGroup]="form" (ngSubmit)="submit()">
  <div fxLayout="column" fxLayoutGap="8px">
    <mat-form-field>
      <mat-label>{{ 'name' | translate }}</mat-label>
      <input matInput formControlName="name" type="text" maxlength="100">
      <mat-error *ngIf="controlHasError('name', 'required')">
        {{ 'required' | translate }}
      </mat-error>
      <mat-error *ngIf="controlHasError('name', 'nameExists')">
        {{ 'nameExists' | translate }}
      </mat-error>
      <mat-error *ngIf="controlHasError('name', 'maxLength')">
        {{ 'maxLength' | translate : { value : 100 } }}
      </mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>
        {{ 'setOfFiltersType' | translate }}
      </mat-label>
      <mat-select formControlName="type">
        <mat-option *ngFor="let setTypeName of getSetOfFiltersTypesForUser()" [value]="setTypeName">
          <span>{{ (setTypeName | snakeCaseToCamelCase | lowercase) + 'Set' | translate }}</span>
        </mat-option>
      </mat-select>
      <mat-error *ngIf="controlHasError('type', 'required')">
        {{ 'required' | translate }}
      </mat-error>
    </mat-form-field>

  </div>

  <mat-dialog-actions>
    <button mat-button mat-dialog-close [disabled]="isSubmitted">{{ 'close' | translate }}</button>
    <button mat-button type="submit" [disabled]="isSubmitDisabled()">
      {{ 'save' | translate }}
    </button>
  </mat-dialog-actions>
</form>